import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import {
  TextFacebook
} from "./styles"

import {
  PageTitleContainer,
  PageIcon,
  PageTitle,
  SearchDivision,
  SearchIcon,
  SearchBox,
  SearchTags,
  SearchTag,
  SearchTagClose,
  TagsBox,
  Tag,
  DivisionSearchIcon,
  TitleIconDivision,
  FacebookLink,
  BoxMobile,
} from "~/pages/Training/styles";
import "~/components/styles/Global.css";
import api from "~/services/api";
import treinamentoIcon from "~/assets/images/ic_treinamento.svg";
import searchIcon from "~/assets/images/search-blue.svg";
import facebookBaloon from "~/assets/images/facebook_baloon.png";

export default function HeaderTraining() {
  const dispatch = useDispatch();

  const tags = useSelector((state) => state.trainingReducer.tags);
  const publicos = useSelector((state) => state.trainingReducer.publicos);
  const allVideos = useSelector((state) => state.videoReducer.allVideos);
  const trainingReducer = useSelector((state) => state.trainingReducer);
  const [selectedVideoTag, setSelectedVideoTag] = useState({
    tag: null,
    title: null,
  });
  const [linkFacebook, setLinkFacebook] = useState(true);

  const getPublicos = async () => {
    const header = {
      "Content-Type": "application/json",
      access_token: await localStorage.getItem("access_token"),
    };
    const parameters = {
      headers: header,
    };
    api
      .get("/residential/ultratop/v1/publicos", parameters)
      .then((res) => {
        res.data.data.map((publico) => {
          if (
            trainingReducer.publicoSelected.publico_titulo ===
            publico.publico_titulo
          ) {
            publico["selected"] = true;
          } else {
            publico["selected"] = false;
          }
          return null;
        });
        dispatch({ type: "SET_PUBLICOS", publicos: res.data.data });
        dispatch({ type: "SET_PUBLICO_FROM_HOME", publicoFromHome: false });
      })
      .catch((err) => {
      });
  };

  useEffect(() => {
    let date = new Date();
    if(date.getFullYear() === 2021) {
      if((date.getMonth() + 1) > 5) {
        setLinkFacebook(false)
      }
    } else {
      setLinkFacebook(false)
    }
    getPublicos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setPublicsFalse = () => {
    let newPublics = publicos;
    for (let index = 0; index < newPublics.length; index++) {
      if (newPublics[index].selected) {
        newPublics[index].selected = false;
      }
    }
    dispatch({ type: "SET_PUBLICOS", publicos: newPublics });
  };

  const activeTag = (selected, index) => {
    if(selected) {
      setPublicsFalse();
      dispatch({
        type: "SET_PUBLICO_SELECTED",
        publicoSelected: null,
      });
      dispatch({ type: "SET_PAGE_VIDEO", page: 1 });
    } else {
      setPublicsFalse();
      let newPublics = publicos;
      newPublics[index].selected = true;
      dispatch({ type: "SET_PUBLICOS", publicos: newPublics });
      dispatch({
        type: "SET_PUBLICO_SELECTED",
        publicoSelected: newPublics[index],
      });
      dispatch({ type: "SET_PAGE_VIDEO", page: 1 });
    }
  }

  const changeSearchBox = (event, newValue) => {
    let option = trainingReducer.videoTags.filter(
      (item) => item.title === newValue
    );
    if (option[0].isTag) {
      dispatch({ type: "SET_TITLE_SELECTED", titleSelected: null });
      let insertTag = {
        tag: option[0],
        title: null,
      };
      setSelectedVideoTag(insertTag);
      let tagDispatchSelected = tags.filter(
        (element) => element.tag_titulo === insertTag.tag.title
      );
      dispatch({
        type: "SET_TAG_SELECTED",
        tagSelected: tagDispatchSelected[0],
      });
    } else {
      dispatch({ type: "SET_TAG_SELECTED", tagSelected: null });
      let insertTitle = {
        tag: null,
        title: option[0],
      };
      setSelectedVideoTag(insertTitle);
      let tagDispatchSelected = allVideos.filter(
        (element) =>
          element.video_titulo === insertTitle.title.title
      );
      if (
        tagDispatchSelected.length < 1 &&
        insertTitle.title.title !== null
      ) {
        dispatch({
          type: "SET_TITLE_SELECTED",
          titleSelected: insertTitle.title.title,
        });
      } else {
        dispatch({
          type: "SET_TITLE_SELECTED",
          titleSelected: tagDispatchSelected[0],
        });
      }
    }
  }

  function TagSelectedView() {
    if (selectedVideoTag.tag === null && selectedVideoTag.title === null) {
      return null;
    } else if (
      selectedVideoTag.tag !== null &&
      selectedVideoTag.title === null
    ) {
      return (
        <SearchTag>
          {selectedVideoTag.tag.title}
          <SearchTagClose
            onClick={() => {
              let removeTag = {
                tag: null,
                title: selectedVideoTag.title,
              };
              setSelectedVideoTag(removeTag);
              dispatch({ type: "SET_TAG_SELECTED", tagSelected: null });
              dispatch({ type: "SET_TITLE_SELECTED", titleSelected: null });
            }}
          >
            x
          </SearchTagClose>
        </SearchTag>
      );
    } else {
      return (
        <SearchTag>
          {selectedVideoTag.title.title}
          <SearchTagClose
            onClick={() => {
              let removeTitle = {
                tag: selectedVideoTag.tag,
                title: null,
              };
              setSelectedVideoTag(removeTitle);
              dispatch({ type: "SET_TAG_SELECTED", tagSelected: null });
              dispatch({ type: "SET_TITLE_SELECTED", titleSelected: null });
            }}
          >
            x
          </SearchTagClose>
        </SearchTag>
      );
    }
  };

  return (
    <>
      <PageTitleContainer>
        <TitleIconDivision>
          <PageIcon src={treinamentoIcon} />
          <PageTitle>Treinamentos</PageTitle>
        </TitleIconDivision>
        <TagsBox mobile>
          <BoxMobile>
            {publicos.map((publico, index) => {
              if (publico.selected) {
                return (
                  <Tag
                    selected
                    key={publico.publico_cod}
                    onClick={() => activeTag(true, index)}
                  >
                    {publico.publico_titulo}
                  </Tag>
                );
              } else {
                return (
                  <Tag
                    key={publico.publico_cod}
                    onClick={() => activeTag(false, index)}
                  >
                    {publico.publico_titulo}
                  </Tag>
                );
              }
            })}
            {
              linkFacebook ? (
                <div style={{ display: "flex" }}>
                  <FacebookLink
                    type="button" 
                    target="_blank" 
                    href="https://facebookpararevendedoresultragaz.splashthat.com/"
                  >
                    <img src={facebookBaloon} />
                  </FacebookLink>
                  <TextFacebook>
                    <p>CLIQUE AQUI!</p>
                    Disponível por tempo limitado
                  </TextFacebook>
                </div>
              ) : null
            }
          </BoxMobile>
        </TagsBox>
        <SearchBox>
          <SearchDivision>
            <DivisionSearchIcon>
              <SearchIcon src={searchIcon} />
            </DivisionSearchIcon>
            <Autocomplete
              freeSolo
              id="free-solo-2-demo"
              disableClearable
              value={
                trainingReducer.tagSelected
                  ? trainingReducer.tagSelected
                  : trainingReducer.titleSelected
              }
              onChange={(event, newValue) => changeSearchBox(event, newValue)}
              options={trainingReducer.videoTags.map((option) => option.title)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pesquisar por título ou palavra chave"
                  margin="normal"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </SearchDivision>
          <SearchTags>
            <TagSelectedView />
          </SearchTags>
        </SearchBox>
      </PageTitleContainer>
      <TagsBox desktop>
        {publicos.map((publico, index) => {
          if (publico.selected) {
            return (
              <Tag
                selected
                onClick={() => activeTag(true, index)}
              >
                {publico.publico_titulo}
              </Tag>
            );
          } else {
            return (
              <Tag
                onClick={() => activeTag(false, index)}
              >
                {publico.publico_titulo}
              </Tag>
            );
          }
        })}
        {
          linkFacebook ? (
            <>
              <FacebookLink
                type="button" 
                target="_blank" 
                href="https://facebookpararevendedoresultragaz.splashthat.com/"
              >
                <img src={facebookBaloon} />
              </FacebookLink>
              <TextFacebook>
                <p>CLIQUE AQUI!</p>
                Disponível por tempo limitado
              </TextFacebook>
            </>
          ) : null
        }
      </TagsBox>
    </>
  );
}
